import { TargetGroup } from '../models/TargetGroup';

export const checkTargetGroupMatch = (targetGroups: TargetGroup[], currentTargetGroup: TargetGroup) => {
  return targetGroups.some(el => el.id === currentTargetGroup?.id);
};
